import {
    RECEIVE_PARENT_PAGE_META
} from '../../actions/inlineActions';

const ParentMetadataReducer = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_PARENT_PAGE_META:
            return action.pageMeta;

        default:
            return state;
    }
};

export default ParentMetadataReducer;